import React, { memo, useEffect, useState, version } from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons"; // Add this import
import { getScriptRunError } from "../../../../api/apiCallManager";
import { useMutation } from "@tanstack/react-query";
import useVersionStore from "../../../../components/hooks/useVersionStore";

const LogScriptRunErrorModal = memo((props) => {
  const { latestVersion, setLatestVersion } = useVersionStore(); // Zustand store

  const [errorLogData, setErrorLogData] = useState("");
  const handleCancel = () => {
    setErrorLogData("");
  };
  // Use React Query's useMutation hook to handle the API call
  const mutation = useMutation({
    mutationFn: getScriptRunError,
    onSuccess: (data) => {
      if (data.statusCode == 200) {
        setErrorLogData(data);
      }
    },
  });

  // Trigger API call when the modal is opened
  useEffect(() => {
    if (props.showLogError) {
      if (props?.scriptType == "train-model") {
        mutation.mutate({
          event_type: "get_error_logs",
          projectKey: props?.rowItems?.celStatus?.project_key,
          scriptType: props?.scriptType,
          version: latestVersion,
        });
      } else {
        mutation.mutate({
          event_type: "get_error_logs",
          projectKey: props?.rowItems?.celStatus?.project_key,
          scriptType: props?.scriptType,
          clientName: props?.rowItems?.clientName,
          region: props?.rowItems?.region,
          version: latestVersion,
        });
      }
    }
  }, [props.showLogError]);

  return (
    <>
      {/* {JSON.stringify(props?.rowItems?.celStatus?.project_key)} */}
      <Modal
        width={600}
        title={
          <span>
            <ExclamationCircleOutlined
              style={{ color: "red", marginRight: 8 }}
            />
            Script Run Error
          </span>
        }
        open={errorLogData}
        onCancel={handleCancel}
        footer={null}
      >
        <div className="w-[570px]  max-h-[580px] overflow-auto">
          {mutation.isLoading && <p>Loading...</p>}
          <p
            dangerouslySetInnerHTML={{
              __html: errorLogData?.body?.replace(/\n/g, "<br />"),
            }}
          ></p>
        </div>
      </Modal>
    </>
  );
});

export default LogScriptRunErrorModal;
